<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ partner.title }}</strong>
                </CCardHeader>
                <CCardBody>
                    <PartnersTabLinks />
                    <CRow class="pl-3 pb-3" />
                    <CRow v-for="restaurant in restaurants" :key="restaurant.title">
                        <CCol
                            tag="label"
                            sm="6"
                            class="col-form-label">
                            {{ restaurant.title }}
                        </CCol>
                        <CCol sm="6">
                            <CSwitch
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="restaurantsEnabled[restaurant.id]"
                            />
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import PartnersTabLinks from '@/components/partner/PartnersTabLinks';

    export default {

        name: 'PartnerRestaurants',
        components: {
            PartnersTabLinks,
        },

        data() {
            return {
                partner: {},
                restaurants: [],
                restaurantsEnabled: [],
            };
        },

        computed: {},

        mounted() {
            const id = parseInt(this.$route.params.id);
            Vue.axios
                .get('/partners/' + id)
                .then(resp => {
                    const partner = resp.data;
                    if (!partner.restaurants) partner.restaurants = [];
                    this.partner = partner;
                    Vue.axios
                        .get('/restaurants')
                        .then(resp => {
                            this.restaurants = resp.data;
                            this.initRestaurantsEnabled();
                        })
                        .catch(err => {
                            this.$root.$emit('showError', 'Ошибка загрузки данных.');
                        });
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },

        methods: {
            save() {
                this.partner.restaurants = [];
                for (var i = 0; i < this.restaurants.length; i++) {
                    if (this.restaurantsEnabled[this.restaurants[i].id]) {
                        this.partner.restaurants.push(this.restaurants[i].id);
                    }
                }
                Vue.axios
                    .put('/partners/' + this.partner.id + '/restaurants', {
                        restaurants: this.partner.restaurants,
                    })
                    .then(resp => {
                        this.goBack();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка сохранения.');
                    });
            },
            initRestaurantsEnabled() {
                this.restaurantsEnabled = [];
                for (var i = 0; i < this.restaurants.length; i++) {
                    this.restaurantsEnabled[
                        this.restaurants[i].id
                    ] = this.partner.restaurants.includes(this.restaurants[i].id);
                }
            },
            goBack() {
                this.$router.push({ path: '/partners/' + this.partner.id });
            },
        },
    };
</script>
